import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";
import { fetchStore } from "../store/actions";
import { orderDateFromToday, formatISODate } from "../../utils/format";
import { fetchByDate } from "./actions";

export const productSlice = createSlice({
  name: "products",
  initialState: {
    byId: {},
    date: formatISODate(new Date()),
    loading: false,
    loadedDate: null,
    requestId: null,
    error: null,
  },
  reducers: {
    setDate: (state, action) => {
      if (state.date === action.payload) return;
      state.date = action.payload;
      state.byId = {};
      state.loadedDate = null;
      state.requestId = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: {
    [fetchStore.fulfilled]: (state, { payload }) => {
      const earliestDate = orderDateFromToday(
        payload.opening_hours_days_offset ?? 0
      );
      if (state.date < earliestDate) {
        state.date = earliestDate;
        state.byId = {};
        state.loadedDate = null;
        state.requestId = null;
        state.loading = false;
        state.error = null;
      }
    },
    [fetchByDate.pending]: (state, action) => {
      if (action.meta.arg !== state.date) return;
      state.loading = true;
      state.requestId = action.meta.requestId;
      state.loadedDate = null;
      state.byId = {};
      state.error = null;
    },
    [fetchByDate.fulfilled]: (state, action) => {
      if (
        action.meta.arg !== state.date ||
        action.meta.requestId !== state.requestId
      )
        return;
      state.byId = _.keyBy(action.payload, "id");
      state.loading = false;
      state.loadedDate = action.meta.arg;
      state.requestId = null;
    },
    [fetchByDate.rejected]: (state, action) => {
      if (
        action.meta.arg !== state.date ||
        action.meta.requestId !== state.requestId
      )
        return;
      state.loading = false;
      state.requestId = null;
      state.error = "Nie udało się wczytać menu. Spróbuj ponownie.";
    },
  },
});

export default productSlice.reducer;
